<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-card class="overflow-hidden">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <customer-autocomplete-filter
                  :fatherEditedCustomer="filterWorkNotDone"
                  :editedCustomerIndex="-1"
                  :customerName="'quotation_customer_number'"
                  @setFilterCustomer="setNotDoneFilterCustomer"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-text-field
                  :label="$t('quotation_license_plate')"
                  v-model="filterWorkNotDone.LicensePlate"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-autocomplete
                  :items="allSpecialNeedList"
                  item-text="Name"
                  item-value="Id"
                  :label="$t('quotation_special_need')"
                  v-model="filterWorkNotDone.SpecialNeedId"
                  :loading-text="$t('common_get_data')"
                  :no-data-text="$t('common_no_results')"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="getNotDoneWork" color="primary">{{
              $t('quotation_item_new_install_search')
            }}</v-btn>
          </v-card-actions>
        </v-card>
        <v-data-table
          :headers="engineerWorkDataTableHeaders"
          :items="workList"
          class="elevation-1 mt-5"
          :loading="isWorkLoading"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          sort-by="CreateTime"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('engineer_toolbar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog v-model="isShowEditEngineerWorkDialog" fullscreen persistent>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('engineer_card_title') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-row class="mt-2">
                      <v-btn
                        color="primary"
                        :disabled="editedEngineerWork.IsAccept"
                        class="mx-2"
                        @click="clickAccept"
                      >
                        {{ $t('installation_acceptance_tool_accept') }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        :disabled="editedEngineerWork.IsAccept"
                        class="mx-2"
                        @click="isShowNotAcceptDialog = true"
                      >
                        {{ $t('installation_acceptance_tool_not_accept') }}
                      </v-btn>
                      <v-dialog v-model="isShowNotAcceptDialog" persistent>
                        <v-card>
                          <v-card-title class="text-h5">
                            {{ $t('installation_acceptance_dialog_reject_reason') }}
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              outlined
                              v-model="returnReason.Reason"
                              :label="$t('installation_notice_reject_reason')"
                            ></v-textarea>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="isShowNotAcceptDialog = false">
                              {{ $t('common_cancel') }}
                            </v-btn>
                            <v-btn color="green darken-1" text @click="clickNotAccept">
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-btn
                        color="primary"
                        @click="isShowCancelDialog = true"
                        :disabled="
                          editedEngineerWork.IsCancel ||
                            !editedEngineerWork.IsAccept ||
                            editedEngineerWork.IsDone
                        "
                        class="mx-2"
                      >
                        {{ $t('common_cancel') }}
                      </v-btn>
                      <v-dialog v-model="isShowCancelDialog" persistent>
                        <v-card>
                          <v-card-title class="text-h5">
                            填寫取消原因
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              outlined
                              v-model="returnReason.Reason"
                              label="取消原因"
                            ></v-textarea>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="isShowCancelDialog = false">
                              {{ $t('common_cancel') }}
                            </v-btn>
                            <v-btn color="green darken-1" text @click="isCancelBtn">
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <input
                        type="file"
                        ref="file"
                        style="display: none"
                        multiple="multiple"
                        @change="uploadPhoto"
                      />
                      <v-btn
                        fab
                        text
                        small
                        color="primary"
                        @click="openFileDialog"
                        :disabled="
                          !editedEngineerWork.IsAccept ||
                            editedEngineerWork.IsDone ||
                            editedEngineerWork.IsOutOfTime
                        "
                      >
                        <v-icon>
                          mdi-paperclip
                        </v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        v-if="editedEngineerWork.IsOutOfTime"
                        class="mx-2"
                        @click="isShowOutOfTimeDialog = true"
                      >
                        回報超時原因
                      </v-btn>
                      <v-dialog v-model="isShowOutOfTimeDialog" persistent>
                        <v-card>
                          <v-card-title class="text-h5">
                            {{ $t('engineer_out_of_time_title') }}
                          </v-card-title>
                          <v-card-text>
                            <ValidationObserver ref="dialogOutOfTime">
                              <ValidationProvider
                                :name="$t('engineer_out_of_time_reason')"
                                rules="required"
                                v-slot="{ errors }"
                              >
                                <v-textarea
                                  outlined
                                  v-model="returnReason.Reason"
                                  :error-messages="errors[0]"
                                >
                                  <template v-slot:label>
                                    <span class="red--text">
                                      <strong>* </strong>
                                    </span>
                                    {{ $t('engineer_out_of_time_reason') }}
                                  </template>
                                </v-textarea>
                              </ValidationProvider>
                            </ValidationObserver>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="isShowOutOfTimeDialog = false">
                              {{ $t('common_cancel') }}
                            </v-btn>
                            <v-btn color="green darken-1" text @click="clickOutOfTime">
                              {{ $t('common_confirm') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <v-spacer></v-spacer>
                      <div style="color:red;" v-if="editedEngineerWork.IsOutOfTime">
                        <v-icon color="error">
                          mdi-alert-box
                        </v-icon>
                        {{ $t('engineer_out_of_time_status') }}
                      </div>
                      <div style="color:red;" v-if="!editedEngineerWork.IsAccept">
                        <v-icon color="error">
                          mdi-alert-box
                        </v-icon>
                        {{ $t('installation_acceptance_status_is_accept') }}
                      </div>
                      <div
                        style="color:green; "
                        v-if="
                          editedEngineerWork.IsAccept &&
                            !editedEngineerWork.IsDone &&
                            !editedEngineerWork.IsOutOfTime
                        "
                      >
                        <v-icon color="success">
                          mdi-checkbox-marked-outline
                        </v-icon>
                        {{ $t('installation_acceptance_status_accept') }}
                      </div>
                      <div
                        style="color:green;"
                        v-if="
                          editedEngineerWork.IsDone &&
                            !editedEngineerWork.IsTrack &&
                            !editedEngineerWork.IsAcceptance
                        "
                      >
                        <v-icon color="success">
                          mdi-checkbox-marked-outline
                        </v-icon>
                        {{ $t('installation_acceptance_status_done') }}
                      </div>
                    </v-row>
                  </v-card-text>
                  <v-tabs>
                    <v-tab href="#tab-1">{{ tabOneTitle }}</v-tab>
                    <v-tab
                      href="#tab-2"
                      v-if="
                        editedEngineerWork.FixFileNameList &&
                          editedEngineerWork.FixFileNameList.length > 0
                      "
                      >{{ $t('repair_fix_photo') }}</v-tab
                    >
                    <v-tab
                      href="#tab-3"
                      v-if="
                        editedEngineerWork.FileNameList &&
                          editedEngineerWork.FileNameList.length > 0
                      "
                      >{{ $t('installation_acceptance_engineer_photo') }}</v-tab
                    >
                    <v-tab
                      href="#tab-4"
                      v-if="
                        editedEngineerWork.NumberType === 9 &&
                          editedEngineerWork.FixType !== 1 &&
                          editedEngineerWork.FixType !== 2 &&
                          editedEngineerWork.FixType !== 12
                      "
                      >{{ $t('engineer_in_car_item') }}</v-tab
                    >
                    <v-tab href="#tab-5" v-if="editedEngineerWork.NumberType === 9">{{
                      $t('quotation_tab_third')
                    }}</v-tab>
                    <v-tab-item value="tab-1">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.Number"
                                  :label="$t('engineer_number')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="turnDate"
                                  :label="$t('installation_notice_create_time')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  :items="allSpecialNeedList"
                                  item-text="Name"
                                  item-value="Name"
                                  :label="$t('quotation_special_need')"
                                  disabled
                                  v-model="editedEngineerWork.SpecialNeedList"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  return-object
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.Brand"
                                  disabled
                                  label="廠牌/車型"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerNumber"
                                  :label="$t('quotation_customer_number')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerName"
                                  :label="$t('quotation_shortname')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CustomerFullName"
                                  :label="$t('quotation_full_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.CarPlace"
                                  :label="$t('quotation_car_place')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_first_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.FirstContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.FirstContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_second_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.SecondContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.SecondContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="blue--text">
                                {{ $t('engineer_third_contact') }}
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.ThirdContactName"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.ThirdContactPhone"
                                  :label="$t('installation_notice_contact_name')"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <ValidationObserver ref="work">
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedEngineerWork.LicensePlate"
                                    :label="$t('quotation_license_plate')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <v-text-field
                                    v-model="editedEngineerWork.OriginalLicensePlate"
                                    :label="$t('quotation_original_license_plate')"
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('installation_notice_engineer')"
                                    rules="required"
                                    v-slot="{ errors }"
                                  >
                                    <v-autocomplete
                                      :items="maintenanceEngineers"
                                      item-text="NickName"
                                      item-value="UserName"
                                      v-model="editedEngineerWork.MaintenanceEngineers"
                                      :error-messages="errors[0]"
                                      :loading-text="$t('common_get_data')"
                                      :no-data-text="$t('common_no_results')"
                                      :disabled="
                                        !editedEngineerWork.IsAccept ||
                                          editedEngineerWork.IsDone ||
                                          editedEngineerWork.IsOutOfTime
                                      "
                                      small-chips
                                      multiple
                                      @keydown.enter="setKeyDownAutocomplete"
                                      @keyup.enter="setKeyUpAutocomplete"
                                      ref="engineerAutocomplete"
                                    >
                                      <template v-slot:label>
                                        <span class="red--text">
                                          <strong>* </strong>
                                        </span>
                                        {{ $t('installation_notice_engineer') }}
                                      </template>
                                    </v-autocomplete>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="3" md="3" lg="3" xl="3">
                                  <ValidationProvider
                                    :name="$t('installation_notice_point')"
                                    :rules="{ required: true, regex: /^[0-9]+$/ }"
                                    v-slot="{ errors }"
                                  >
                                    <v-text-field
                                      v-model="editedEngineerWork.Point"
                                      :label="$t('installation_notice_point')"
                                      disabled
                                      :error-messages="errors[0]"
                                    ></v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="
                                  editedEngineerWork.NumberType === 9 &&
                                    editedEngineerWork.FixType !== 1 &&
                                    editedEngineerWork.FixType !== 2 &&
                                    editedEngineerWork.FixType !== 12
                                "
                              >
                                <v-col>
                                  <v-textarea
                                    outlined
                                    v-model="editedEngineerWork.FixReason"
                                    :label="$t('fix_reason')"
                                    disabled
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedEngineerWork.Remark"
                                    :label="$t('fix_dispatch_remark')"
                                    disabled
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedEngineerWork.InternalRemark"
                                    :label="$t('fix_internal_remark')"
                                    disabled
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-textarea
                                    outlined
                                    v-model="editedEngineerWork.EngineerRemark"
                                    :label="$t('fix_engineer_remark')"
                                    :disabled="
                                      !editedEngineerWork.IsAccept || editedEngineerWork.IsDone
                                    "
                                    rows="2"
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                            </ValidationObserver>
                          </v-container>
                        </v-card-text>

                        <!-- 維修工單 -->
                        <engineer-work-not-done-repair
                          v-if="
                            editedEngineerWork.NumberType === 9 &&
                              editedEngineerWork.FixType !== 1 &&
                              editedEngineerWork.FixType !== 2 &&
                              editedEngineerWork.FixType !== 12
                          "
                          :headerProps="headerProps"
                          :editedEngineerWork="editedEngineerWork"
                          :isAllTextFieldDisable="isAllTextFieldDisable"
                          :allInstallPositionType="allInstallPositionType"
                          :inCarItemList="inCarItemList"
                          :customerDeviceTypeList="customerDeviceTypeList"
                        />
                        <!-- 拆機工單 -->
                        <engineer-work-not-done-remove
                          v-if="
                            editedEngineerWork.NumberType === 9 &&
                              (editedEngineerWork.FixType === 1 ||
                                editedEngineerWork.FixType === 2 ||
                                editedEngineerWork.FixType === 12)
                          "
                          :headerProps="headerProps"
                          :editedEngineerWork="editedEngineerWork"
                          :isAllTextFieldDisable="isAllTextFieldDisable"
                          :allInstallPositionType="allInstallPositionType"
                          :customerDeviceTypeList="customerDeviceTypeList"
                        />
                        <!-- 驗收未完成工單 -->
                        <engineer-work-not-done-acceptance
                          v-if="editedEngineerWork.NumberType === 8"
                          :headerProps="headerProps"
                          :editedEngineerWork="editedEngineerWork"
                          :isAllTextFieldDisable="isAllTextFieldDisable"
                          :allInstallPositionType="allInstallPositionType"
                          :inCarItemList="inCarItemList"
                          :customerDeviceTypeList="customerDeviceTypeList"
                        />
                      </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-row>
                        <v-col cols="2" v-for="fixImage in fixImageList" :key="fixImage">
                          <v-card flat>
                            <v-img :src="fixImage"></v-img>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="4"
                          md="3"
                          v-for="(repairImage, index) in repairImageList"
                          :key="repairImage"
                        >
                          <v-card flat class="photo-card">
                            <v-img
                              :src="repairImage"
                              aspect-ratio="1"
                              class="grey lighten-2 photo-thumbnail"
                              @click="openPreviewImage(repairImage)"
                            >
                              <template v-slot:placeholder>
                                <v-row class="fill-height ma-0" align="center" justify="center">
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="error" small @click="deletePhoto(index)">{{
                                $t('common_delete')
                              }}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-dialog
                        v-model="isShowPreviewImageDialog"
                        fullscreen
                        hide-overlay
                        transition="dialog-bottom-transition"
                      >
                        <v-card class="preview-dialog-card d-flex flex-column">
                          <v-card-title class="pa-2 flex-grow-0">
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="isShowPreviewImageDialog = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-card-text
                            class="pa-2 d-flex align-center justify-center flex-grow-1 preview-image-container"
                            @click.self="isShowPreviewImageDialog = false"
                          >
                            <img :src="previewImageSrc" class="preview-image" />
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                      <v-data-table
                        :headers="inCarItemDataTableHeaders"
                        :items="inCarItemList"
                        class="elevation-1 my-5 mx-5"
                        :search="searchInCarItem"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_data')"
                        :no-results-text="$t('common_no_results')"
                        :footer-props="{
                          'items-per-page-options': [30, 50, 100],
                          'items-per-page-text': $t('item_rows_per_page'),
                        }"
                        :header-props="headerProps"
                        :item-class="isOutOfWarrantyInCarClass"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="searchInCarItem"
                              append-icon="mdi-magnify"
                              :label="$t('quotation_item_new_install_search')"
                              single-line
                              hide-details
                              clearable
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                        <template v-slot:[`item.InstallPosition`]="{ item }">
                          {{ turnData(item.InstallPosition) }}
                        </template>
                        <template v-slot:[`item.BuyOrRentType`]="{ item }">
                          {{ turnBuyOrRentType(item.BuyOrRentType) }}
                        </template>
                      </v-data-table>
                    </v-tab-item>
                    <v-tab-item value="tab-5">
                      <v-card flat>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.TpAccount"
                                  label="環保帳號"
                                  disabled
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedEngineerWork.TpPassword"
                                  label="環保密碼"
                                  disabled
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      :disabled="
                        !editedEngineerWork.IsAccept ||
                          editedEngineerWork.IsDone ||
                          editedEngineerWork.IsOutOfTime
                      "
                      @click="isDone"
                      class="mx-2"
                    >
                      {{ $t('installation_acceptance_is_done') }}
                    </v-btn>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="closeEditedEngineerWork"
                      :disabled="isAllTextFieldDisable"
                    >
                      {{ $t('common_close') }}
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      text
                      @click="saveEditedEngineerWork"
                      :loading="isLoadingSaveBtn"
                      :disabled="editedEngineerWork.IsDone || editedEngineerWork.IsOutOfTime"
                    >
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.Edit`]="{ item }">
            <v-btn icon @click="isShowEditEngineerWorkDialogBtn(item)">
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            {{ methodsStatus(item) }}
          </template>
          <template v-slot:[`item.NumberType`]="{ item }">
            {{ turnNumberTypeName(item.NumberType) }}
          </template>
          <template v-slot:[`item.SpecialNeedList`]="{ item }">
            {{ turnSpecialNeedName(item.SpecialNeedList) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
.red {
  background-color: red !important;
}
.yellow {
  background-color: yellow !important;
}
.preview-dialog-card {
  background: rgba(0, 0, 0, 0.9);
}
.preview-image-container {
  overflow: auto;
}
.preview-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  touch-action: pinch-zoom;
}
.photo-thumbnail {
  cursor: pointer;
}
.photo-card {
  border: 1px solid #e0e0e0;
}
</style>
<script>
import CustomerAutocompleteFilter from '@/components/CustomerAutocompleteFilter.vue'
import EngineerWorkNotDoneAcceptance from '@/components/EngineerWorkNotDoneAcceptance.vue'
import EngineerWorkNotDoneRemove from '@/components/EngineerWorkNotDoneRemove.vue'
import EngineerWorkNotDoneRepair from '@/components/EngineerWorkNotDoneRepair.vue'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import { NumberType } from '@/js/NumberType'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import {
  HttpEngineerWork,
  HttpQuotation,
  HttpSerialNumber,
  HttpFix,
  HttpRepair,
  HttpInstallationAcceptance,
  HttpInstallPosition
} from '@/js/http-Manager'

export default {
  components: {
    CustomerAutocompleteFilter,
    EngineerWorkNotDoneRepair,
    EngineerWorkNotDoneRemove,
    EngineerWorkNotDoneAcceptance
  },
  name: 'EngineerWorkNotDone',
  props: {
    maintenanceEngineers: {
      type: Array
    },
    allSpecialNeedList: {
      type: Array
    },
    headerProps: {
      type: Object
    },
    getUserAccountId: {
      type: String
    },
    tabTitle: {
      type: String
    }
  },
  data: () => ({
    filterWorkNotDone: {
      LicensePlate: '',
      CustomerId: '',
      SpecialNeedId: ''
    },
    workList: [],
    isWorkLoading: false,
    isShowEditEngineerWorkDialog: false,
    editedEngineerWorkIndex: -1,
    editedEngineerWork: {
      NumberType: 8,
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      FixType: 0,
      CarPlace: '',
      LicensePlate: '',
      Point: 0,
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      IsDone: false,
      DoneTime: 0,
      EngineerWorkItems: [],
      FixNumber: '',
      FileNameList: [],
      FixFileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      FixReason: '',
      IsCancel: false,
      InternalRemark: '',
      EngineerRemark: ''
    },
    defaultEngineerWork: {
      NumberType: 8,
      CustomerId: '',
      Number: '',
      CustomerNumber: '',
      CustomerName: '',
      CustomerFullName: '',
      FirstContactName: '',
      FirstContactPhone: '',
      SecondContactName: '',
      SecondContactPhone: '',
      ThirdContactName: '',
      ThirdContactPhone: '',
      FixType: 0,
      CarPlace: '',
      LicensePlate: '',
      Point: 0,
      MaintenanceEngineers: [],
      IsAccept: false,
      AcceptTime: 0,
      IsOutOfTime: false,
      IsDone: false,
      DoneTime: 0,
      EngineerWorkItems: [],
      FixNumber: '',
      FileNameList: [],
      FixFileNameList: [],
      SpecialNeedList: [],
      TpAccount: '',
      TpPassword: '',
      Brand: '',
      Remark: '',
      FixReason: '',
      IsCancel: false
    },
    customerDeviceTypeList: [],
    isShowNotAcceptDialog: false,
    isShowCancelDialog: false,
    returnReason: {
      Reason: '',
      Number: '',
      NumberType: 8,
      IsCancel: false
    },
    defaultReason: {
      Reason: '',
      Number: '',
      NumberType: 8,
      IsCancel: false
    },
    isShowOutOfTimeDialog: false,
    inCarItemList: [],
    searchInCarItem: '',
    fixImageList: [],
    repairImageList: [],
    isShowPreviewImageDialog: false,
    previewImageSrc: '',
    isAllTextFieldDisable: false,
    isLoadingSaveBtn: false,
    engineerList: [],
    tempChangeItem: null,
    tempOriginalItem: null,
    allInstallPositionType: []
  }),
  async mounted () {
    await this.getNotDoneWork()
    await this.getCustomerDeviceType()
    await this.getAllInstallPositionType()
  },
  watch: {
    async tabTitle (val) {
      if (val === 'tab-2') {
        await this.getNotDoneWork()
      }
    }
  },
  computed: {
    engineerWorkDataTableHeaders () {
      return [
        { text: this.$t('engineer_number_type'), align: 'start', value: 'NumberType' },
        { text: this.$t('quotation_customer_number'), align: 'start', value: 'CustomerNumber' },
        { text: this.$t('quotation_shortname'), align: 'start', value: 'CustomerName' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        {
          text: this.$t('quotation_car_place'),
          align: 'start',
          value: 'CarPlace'
        },
        {
          text: this.$t('quotation_special_need'),
          align: 'start',
          value: 'SpecialNeedList'
        },
        { text: this.$t('fix_reason'), align: 'start', value: 'FixReason' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    turnDate () {
      return this.convertToDateTimeFormat(this.editedEngineerWork.CreateTime)
    },

    inCarItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'BomName',
          sortable: false
        },
        {
          text: this.$t('quotation_item_name'),
          align: 'start',
          value: 'ItemName',
          sortable: false
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'BuyOrRentType',
          sortable: false
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'end',
          value: 'InstallPosition',
          sortable: false
        },
        {
          text: this.$t('bom_item_quantity'),
          align: 'end',
          value: 'Quantity',
          sortable: false
        },
        {
          text: this.$t('engineer_is_out_of_warranty'),
          align: 'end',
          value: 'IsOutOfWarranty',
          sortable: false
        }
      ]
    },
    tabOneTitle () {
      if (this.editedEngineerWork.NumberType === 9) {
        return this.$t('engineer_name_one')
      } else {
        return this.$t('engineer_name_two')
      }
    }
  },
  methods: {
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : []
    },
    async setNotDoneFilterCustomer (val) {
      this.filterWorkNotDone.CustomerId = val.Id
      this.filterWorkNotDone = JSON.parse(JSON.stringify(this.filterWorkNotDone))
    },
    turnData (value) {
      return ItemInstallPositionType.getFormInstallPositionTypeName(
        value,
        this.allInstallPositionType
      )
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    methodsStatus (value) {
      if (!value.IsAccept) {
        return this.$t('installation_acceptance_status_is_accept')
      } else if (value.IsAccept && !value.IsDone) {
        return this.$t('installation_acceptance_status_accept')
      } else if (value.IsDone && !value.IsTrack && !value.IsAcceptance) {
        return this.$t('installation_acceptance_status_done')
      } else {
        return this.$t('installation_acceptance_status_is_accept')
      }
    },
    turnNumberTypeName (val) {
      return NumberType.NumberTypeName(val)
    },
    turnSpecialNeedName (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(element.Name)
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    async getNotDoneWork () {
      this.isWorkLoading = true
      let response = await HttpEngineerWork.GetNotDoneWork({
        customerId: this.filterWorkNotDone.CustomerId,
        licensePlate: this.filterWorkNotDone.LicensePlate,
        userName: this.getUserAccountId,
        specialNeedId: this.filterWorkNotDone.SpecialNeedId
      })
      this.workList = response.status === 200 ? response.data.Data : []
      this.isWorkLoading = false
    },
    async clickAccept () {
      this.editedEngineerWork.IsAccept = true
      await HttpEngineerWork.UpdateWorkAccept(this.editedEngineerWork)
      await this.getNotDoneWork()
    },
    async clickNotAccept () {
      this.returnReason.Number = this.editedEngineerWork.Number
      this.returnReason.NumberType = this.editedEngineerWork.NumberType
      await HttpEngineerWork.UpdateRejectReason(this.returnReason)
      this.isShowNotAcceptDialog = false
      await this.getNotDoneWork()
      this.closeEditedEngineerWork()
    },
    async isCancelBtn () {
      this.returnReason.Number = this.editedEngineerWork.Number
      this.returnReason.NumberType = this.editedEngineerWork.NumberType
      this.returnReason.IsCancel = true
      await HttpEngineerWork.UpdateCancelReason(this.returnReason)
      this.returnReason = JSON.parse(JSON.stringify(this.defaultReason))
      this.isShowCancelDialog = false
      await this.getNotDoneWork()
      this.closeEditedEngineerWork()
    },
    async isDone () {
      this.editedEngineerWork.IsDone = true
      await HttpSerialNumber.UpdateSerialNumberForIsDoneByEgWork({
        EngineerWork: this.editedEngineerWork,
        Number: this.editedEngineerWork.Number,
        CustomerId: this.editedEngineerWork.CustomerId
      })
      await HttpEngineerWork.UpdateWork(this.editedEngineerWork)
      await this.searchWork()
    },
    async uploadPhoto (event) {
      if (event.target.files.length > 0) {
        let formData = new FormData()
        for (var i = 0; i < event.target.files.length; i++) {
          formData.append('Files', event.target.files[i])
        }

        formData.append('Number', this.editedEngineerWork.Number)
        if (this.editedEngineerWork.NumberType === 9) {
          await HttpRepair.UploadImage(formData)
        } else {
          await HttpInstallationAcceptance.UploadImage(formData)
        }

        if (!this.editedEngineerWork.FileNameList) {
          this.editedEngineerWork.FileNameList = []
        }
        for (let i = 0; i < event.target.files.length; i++) {
          this.editedEngineerWork.FileNameList.push(event.target.files[i].name)
        }
        await HttpEngineerWork.UpdateWork(this.editedEngineerWork)
        await this.getPhoto()
        await this.searchWork()
      }
    },
    async getPhoto () {
      if (this.editedEngineerWork.FileNameList && this.editedEngineerWork.FileNameList.length > 0) {
        let response
        if (this.editedEngineerWork.NumberType === 9) {
          response = await HttpRepair.GetImage({
            repairNumber: this.editedEngineerWork.Number,
            repairFileList: this.editedEngineerWork.FileNameList.join(',')
          })
        } else {
          response = await HttpInstallationAcceptance.GetImage({
            acceptanceNumber: this.editedEngineerWork.Number,
            acceptanceFileList: this.editedEngineerWork.FileNameList.join(',')
          })
        }

        this.repairImageList = response.status === 200 ? response.data.Data : []
      }
    },
    async getFixPhoto () {
      if (
        this.editedEngineerWork.FixFileNameList &&
        this.editedEngineerWork.FixFileNameList.length > 0
      ) {
        let response = await HttpFix.GetImage({
          fixNumber: this.editedEngineerWork.FixNumber,
          fixFileList: this.editedEngineerWork.FixFileNameList.join(',')
        })
        this.fixImageList = response.status === 200 ? response.data.Data : []
      }
    },
    async searchWork () {
      let response = await HttpEngineerWork.SearchWork({
        id: this.editedEngineerWork.Id,
        numberType: this.editedEngineerWork.NumberType,
        number: this.editedEngineerWork.Number
      })
      this.editedEngineerWork = response.status === 200 ? response.data.Data : {}
    },
    openFileDialog () {
      this.$refs.file.click()
    },
    async clickOutOfTime () {
      const isValid = await this.$refs.dialogOutOfTime.validate()
      if (isValid) {
        this.returnReason.Number = this.editedEngineerWork.Number
        this.returnReason.NumberType = this.editedEngineerWork.NumberType
        await HttpEngineerWork.UpdateRejectReason(this.returnReason)
        this.isShowOutOfTimeDialog = false
        await this.getNotDoneWork()
        this.closeEditedEngineerWork()
      }
    },

    openPreviewImage (src) {
      this.previewImageSrc = src
      this.isShowPreviewImageDialog = true
    },
    async deletePhoto (index) {
      if (this.editedEngineerWork.NumberType === 9) {
        await HttpRepair.DeleteImage({
          repairNumber: this.editedEngineerWork.Number,
          fileName: this.editedEngineerWork.FileNameList[index]
        })
      } else {
        await HttpInstallationAcceptance.DeleteImage({
          acceptanceNumber: this.editedEngineerWork.Number,
          fileName: this.editedEngineerWork.FileNameList[index]
        })
      }
      this.editedEngineerWork.FileNameList.splice(index, 1)
      await HttpEngineerWork.UpdateWork(this.editedEngineerWork)
      await this.getPhoto()
      await this.searchWork()
    },
    async getCarItem () {
      let response = await HttpEngineerWork.GetItemInCar({
        customerId: this.editedEngineerWork.CustomerId,
        licensePlate: this.editedEngineerWork.LicensePlate
      })
      this.inCarItemList = response.status === 200 ? response.data.Data : []
    },
    isOutOfWarrantyInCarClass (item) {
      if (item.IsOutOfWarranty && item.BuyOrRentType === 1) {
        return 'red'
      }
    },
    async saveEditedEngineerWork () {
      await HttpEngineerWork.UpdateWork(this.editedEngineerWork)
      await this.getNotDoneWork()
      this.closeEditedEngineerWork()
    },
    async closeEditedEngineerWork () {
      this.isShowEditEngineerWorkDialog = false
      this.$nextTick(() => {
        this.returnReason = JSON.parse(JSON.stringify(this.defaultReason))
        this.editedEngineerWork = JSON.parse(JSON.stringify(this.defaultEngineerWork))
        this.editedEngineerWorkIndex = -1
      })
      await this.getNotDoneWork()
    },
    async isShowEditEngineerWorkDialogBtn (item) {
      this.editedEngineerWorkIndex = this.workList.indexOf(item)
      this.editedEngineerWork = JSON.parse(JSON.stringify(item))
      this.editedEngineerWork.EngineerWorkItems = JSON.parse(
        JSON.stringify(this.editedEngineerWork.EngineerWorkItems)
      )
      await this.getFixPhoto()
      await this.getPhoto()

      if (
        this.editedEngineerWork.NumberType === 9 &&
        this.editedEngineerWork.FixType !== 1 &&
        this.editedEngineerWork.FixType !== 2 &&
        this.editedEngineerWork.FixType !== 12
      ) {
        let response = await HttpEngineerWork.UpdateIsOutOfRepairWarranty(item)
        this.editedEngineerWork = response.status === 200 ? response.data.Data : {}
        await this.getCarItem()
      }
      this.isShowEditEngineerWorkDialog = true
    },

    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.engineerList = this.editedEngineerWork.MaintenanceEngineers
    },
    setKeyUpAutocomplete (event) {
      this.$refs.engineerAutocomplete.isMenuActive = false
      this.$refs.engineerAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedEngineerWork.MaintenanceEngineers = this.engineerList
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    }
  }
}
</script>
